import type {
    GenericObject,
    IPenciledInputs,
    IPencilOfferInputs,
    OfferType,
    PenciledInputOfferType
} from '@makemydeal/dr-platform-types';

export const buildDueAtSigningPenciledInputsState = (
    penciledInputs: IPenciledInputs,
    overrides: GenericObject,
    offerType: OfferType
): IPenciledInputs => {
    return {
        ...penciledInputs,
        byOfferType: {
            ...penciledInputs?.byOfferType,
            [offerType]: {
                ...penciledInputs?.byOfferType?.[offerType],
                isUpdatedByUser: true,
                ...overrides
            }
        } as { [offerType in PenciledInputOfferType]: IPencilOfferInputs }
    };
};
